<div>
  <appMetadataWidget [data]="data"></appMetadataWidget>
  <div class="metadata-block">
    <!--<div class="metadata-key">Key(s)</div>
        <div class="metadata-value">{{data.key}}</div>-->
    <!--<div class="metadata-key">Sequence:</div>
        <div class="metadata-value">{{data.seq}}</div>-->
    <div class="metadata-column">
      <div *ngIf="isEditableQuestion" class="metadata-key">Name</div>
      <div class="metadata-input-block">
        <mat-icon *ngIf="isEditableQuestion" matPrefix class="metadata-input-icon"
          class="edit-icon">mode_edit</mat-icon>
        <input [readOnly]="!isEditableQuestion" type="text" fxFlex="flex-grow" class="metadata-input-field"
          [(ngModel)]="data.name" [title]="data.name">
      </div>
      <div *ngIf="isEditableQuestion" class="metadata-key">Description</div>
      <div *ngIf="isEditableQuestion" class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon" class="edit-icon">mode_edit</mat-icon>
        <input [readOnly]="!isEditableQuestion" type="text" fxFlex="flex-grow" class="metadata-input-field"
          [(ngModel)]="data.description" [title]="data.description">
      </div>
      <div *ngIf="isEditableQuestion" class="metadata-key">Namespace</div>
      <div *ngIf="isEditableQuestion" class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon" class="edit-icon">mode_edit</mat-icon>
        <input [readOnly]="!isEditableQuestion" type="text" fxFlex="flex-grow" class="metadata-input-field"
          [(ngModel)]="data.key" [title]="data.key">
      </div>
    </div>


    <div class="metadata-property">
      <div class="metadata-key">Data Type</div>
      <div *ngFor="let dataType of dataTypes" class="metadata-value">
        <container-element [ngSwitch]="data.typeId">
          <img class="type-icon" *ngSwitchCase="1" src="assets/img/questions/yes_no.png" />
          <img class="type-icon" *ngSwitchCase="2" src="assets/img/questions/year.png" />
          <img class="type-icon" *ngSwitchCase="3" src="assets/img/questions/clock.png" />
          <img class="type-icon" *ngSwitchCase="4" src="assets/img/questions/complex.png" />
          <img class="type-icon" *ngSwitchCase="5" src="assets/img/questions/money.png" />
          <img class="type-icon" *ngSwitchCase="6" src="assets/img/questions/percentage.png" />
          <img class="type-icon" *ngSwitchCase="7" src="assets/img/questions/text.png" />
          <img class="type-icon" *ngSwitchCase="8" src="assets/img/questions/numericnew.png" />
          <img class="type-icon" *ngSwitchDefault src="assets/img/questions/yes_no.png" />
        </container-element>
        - {{dataType}}
      </div>
    </div>
    <div class="metadata-property">
      <div class="metadata-key">Keys</div>
      <div *ngFor="let key of keysList" class="metadata-value" [title]="key">{{key}}</div>
    </div>
    <div class="metadata-key">Tags</div>
    <div class="metadata-tag-row">
      <div *ngFor="let tag of tags" class="metadata-tags">
        <div class="metadata-tag-value" [title]="tag">{{tag}}</div>
      </div>
    </div>
    <div *ngIf="isEditableQuestion" class="metadata-key">Comments</div>
    <div *ngIf="isEditableQuestion">
      <div class="metadata-property">
        <mat-label class="metadata-key" for="isCommentRequired">Comment Required </mat-label>
        <input tabindex="1" type="checkbox" id="isCommentRequired" [(ngModel)]="data.isCommentRequired"
          [title]="data.isCommentRequired" />
      </div>
      <div class="metadata-row">
        <mat-label class="metadata-key" for="commentTrigger">commentTrigger</mat-label>
        <input tabindex="1" type="text" id="commentTrigger" class="metadata-input-field"
          [(ngModel)]="data.commentTrigger" [title]="data.commentTrigger" />
      </div>
    </div>
    <!-- For table question -->
    <div *ngIf="isEditableQuestion">
      <div class="metadata-property">
        <mat-label class="metadata-key" for="isTable">Is Table question? </mat-label>
        <input tabindex="1" type="checkbox" id="isTable" [(ngModel)]="data.isTable" [title]="data.isTable" />
      </div>
    </div>
    <!-- For OnPoint question -->
    <div *ngIf="isEditableQuestion">
      <div class="metadata-property">
        <mat-label class="metadata-key" for="isOnPoint">Is OnPoint Question? </mat-label>
        <input tabindex="1" type="checkbox" id="isOnPoint" [(ngModel)]="data.isOnPoint" (ngModelChange)="onToggleOnPointQuestion($event)" [title]="data.isOnPoint" />
      </div>
    </div>
  </div>  <!-- Metadata Question coming from the API call -->
  <div *ngIf="isEdit && isMetadataView">
    <app-metadata-question-api [data]="data" [isEdit]="isEdit"></app-metadata-question-api>
  </div>
  <!-- End Metadata Question coming from the API call -->
  <div class="metadata-block" *ngIf="isQuestionConditionalActive">
    <div class="metadata-key" id="question-visibility">Question Visibility</div>
    <div fxLayout="row wrap">
      <mat-label class="metadata-key">Hide when Unselected<input id="hideActive" type="checkbox"
          [(ngModel)]="hideActive" name="Hide when checkbox selected" (ngModelChange)="onHide($event)"></mat-label>
    </div>
    <div fxLayout="row nowrap">
      <select id="hidefield" class="metadata-select" fxLayout="row" fxFlex="grow" [(ngModel)]="hidefield"
        name="hidefield" (ngModelChange)="onHide($event)">
        <option #condElem *ngFor="let field of conditionalFields" [value]="field.toString()"
          [attr.data-type]="field.type">{{field.toString()}}</option>
      </select>
    </div>
  </div>
  <!-- Label overrides -->
  <div class="metadata-block" *ngIf="data.labelOverrides.size > 0">
    <div class="metadata-key">Label Overrides</div>
    <div fxLayout="row nowrap">
      <div fxFlex="40%" class="metadata-key">Key</div>
      <div fxFlex="grow" class="metadata-key align-right">Value</div>
    </div>
    <div *ngFor="let keyValuePair of data.labelOverrides | keyvalue;let in=index;">
      <div class="metadata-row" fxLayout="row nowrap">
        <input type="text" class="metadata-input" fxFlex="40%" value="{{ trimFirstChar(keyValuePair.key) }}" readonly>
        <div class="metadata-input-block" fxFlex="grow">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input class="metadata-input-field align-right" type="text" fxFlex="grow"
            (change)="changeValue(keyValuePair.key, $any($event.target).value)"
            value="{{data.labelOverrides.get(keyValuePair.key)}}" />
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isShownFromWidgetArea" class="debug-msg">(*) widget</div>
  <div>
    <appMetadataTemplate *ngIf="this.isTemplateVisible" [question]="data" [isQuestionSelected]="isQuestionSelected"
      (modifiedJsonTemplate)="getModifiedTemplate($event)"></appMetadataTemplate>
  </div>
  <div class="metadata-block">
    <div *ngIf="data.dbId">
      <div class="metadata-property">
        <div class="metadata-key">DB Id</div>
        <div class="metadata-value">{{data.dbId}}</div>
      </div>
    </div>
    <div *ngIf="data.createdBy">
      <div class="metadata-property">
        <div class="metadata-key">Last Modified By</div>
        <div class="metadata-value">{{data.createdBy}}</div>
      </div>
    </div>
    <div *ngIf="data.created">
      <div class="metadata-property">
        <div class="metadata-key">Last Modified Date</div>
        <div class="metadata-value">{{ data.created | date:'MM/dd/yyyy h:mm a':'GMT' }}</div>
      </div>
    </div>
  </div>
  <div class="metadata-block">
    <button class="metadata-button-preview" (click)="onPreviewQuestion()">Preview</button>
    <button *ngIf="isUserQuestionEditor && data.dbId" class="metadata-button-preview"
      (click)="onEditQuestion()">Edit</button>
  </div>
  <div *ngIf="isEdit" class="metadata-block">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button class="metadata-button" (click)="onSave()">Save</button>
  </div>
</div>